import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/loadinganimation128.gif'
import _imports_1 from '@/assets/images/loadinganimation64.gif'
import _imports_2 from '@/assets/images/404notfound128.png'


const _withScopeId = n => (_pushScopeId("data-v-096eadbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image d-none d-sm-block",
    src: _imports_0,
    alt: "Loading animation for retrieving items"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "image d-sm-none",
    src: _imports_1,
    alt: "Loading animation for retrieving items"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "image-caption" }, "Retrieving data from server.")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image",
    src: _imports_2,
    alt: "Loading animation for retrieving items"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "image-caption" }, "Error: Could not retrieve data from server")
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.display)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      ]))
    : _createCommentVNode("", true)
}